import React from "react";
import MarketingNav from "@/components/marketing/MarketingNav";
import MarketingFooter from "@/components/marketing/MarketingFooter";
import ToTopButton from "@/components/marketing/ToTopButton";
import MobileTrialBar from "@/components/marketing/MobileTrialBar";

export default function MarketingLayout({ children, hideFooter }) {
  return (
    <div className="min-h-screen bg-[#F8F9FC] pb-16 md:pb-0">
      <MarketingNav />
      <main className="pt-16">{children}</main>
      {!hideFooter && <MarketingFooter />}
      <ToTopButton />
      <MobileTrialBar />
    </div>
  );
}
